module.exports = __webpack_public_path__ + "3b4bf66c442cc7ccf3b402dfccd668ca.pdf";